"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _legacyI18nInit = require("../internal/legacyI18nInit");

var _hsIntl = require("../internal/hs-intl");

var _localeMapper = _interopRequireDefault(require("../internal/localeMapper"));

var localStorage = _interopRequireWildcard(require("../internal/localStorage"));

var _localeCacheKeys = require("../internal/localeCacheKeys");

var _default = function _default(options) {
  var intl = (0, _hsIntl.create)();
  var _setLocale = intl.setLocale,
      _register = intl.register,
      rest = (0, _objectWithoutProperties2.default)(intl, ["setLocale", "register"]);
  var localesToLoad = [];
  var I18nProvider = Object.assign({
    register: function register(lang) {
      var registerOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var mapper = registerOptions.localeMapper || _localeMapper.default;

      var p = _register.call(intl, lang, Object.assign({}, registerOptions, {
        localeMapper: function localeMapper() {
          var l = mapper.apply(void 0, arguments);

          if (l && !localesToLoad.includes(l)) {
            localesToLoad.push(l);
          }

          return l;
        }
      }));

      p.then(function () {
        if (!options || options.__localesCacheKey !== _localeCacheKeys.PUBLIC_CACHE) {
          localStorage.setItem(options && options.__localesCacheKey || _localeCacheKeys.STANDARD_CACHE, JSON.stringify(localesToLoad));
        }
      });
      return p;
    },
    setLocale: function setLocale(_ref) {
      var locale = _ref.locale,
          langEnabled = _ref.langEnabled,
          timezone = _ref.timezone;
      (0, _legacyI18nInit.setManualOverwrites)();
      (0, _legacyI18nInit.setupTimezone)(timezone);
      I18n.locale = I18n.manualLocale || (0, _legacyI18nInit.getValidLocale)(locale);
      I18n.langEnabled = !!I18n.manualLocale || langEnabled;
      var loaderLocales = I18n.langEnabled ? [I18n.locale] : [];

      if (!I18n.langEnabled && I18n.locale === _legacyI18nInit.defaultLanguage) {
        // We still set new users to en instead of en-us if they have never changed their settings
        // We need to load en-us number formats
        loaderLocales.push('en-us');
      }

      var shouldLoadFallback = !(options && options.excludeFallback);

      if (shouldLoadFallback) {
        loaderLocales.push(_legacyI18nInit.defaultLanguage);
      }

      I18n.fired.ready = true;
      I18n.Info.resolve({
        locale: I18n.locale,
        langEnabled: I18n.langEnabled,
        timezone: I18n.timezone
      });

      if (I18n.moment) {
        var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.split('-')[0]];

        if (I18n.moment.locales().indexOf(validMomentLocale) < 0) {
          validMomentLocale = _legacyI18nInit.defaultLanguage;
        }

        if (validMomentLocale !== I18n.moment.locale()) {
          I18n.moment.locale(validMomentLocale);
        }
      }

      (0, _legacyI18nInit.setHtmlLang)();
      return _setLocale(loaderLocales);
    }
  }, rest);
  return I18nProvider;
};

exports.default = _default;
module.exports = exports.default;